// import React from "react";
// import { useTheme } from "../context/ThemeContext";
// import { Button } from "react-bootstrap";
// import { Sun, Moon } from "lucide-react";

// const Header: React.FC = () => {
//   const { darkMode, toggleTheme } = useTheme();

//   return (
//     <div className="d-flex justify-content-between align-items-center p-3 border-bottom">
//       <h5 className="fw-bold">Dashboard</h5>
//       <Button variant={darkMode ? "light" : "dark"} onClick={toggleTheme}>
//         {darkMode ? <Sun size={18} /> : <Moon size={18} />}
//       </Button>
//     </div>
//   );
// };

// export default Header;

// src/components/Header.tsx
import React from "react";
import { useTheme } from "../context/ThemeContext";
import { List } from "lucide-react";

interface HeaderProps {
  onToggleSidebar: () => void;
}

const Header: React.FC<HeaderProps> = ({ onToggleSidebar }) => {
  const { dark, toggle } = useTheme();

  return (
    <header
      className={`header d-flex align-items-center justify-content-between px-3 py-2 ${
        dark ? "bg-dark text-light" : "bg-light text-dark"
      }`}
    >
      {/* ✅ Hamburger Menu (visible on mobile) */}
      <button
        className="btn d-lg-none"
        onClick={onToggleSidebar}
        aria-label="Toggle Sidebar"
      >
        <List size={24} />
      </button>

      <h5 className="fw-bold mb-0">Dashboard</h5>

      {/* ✅ Theme Toggle */}
      <button
        className={`btn btn-sm ${dark ? "btn-light" : "btn-dark"}`}
        onClick={toggle}
      >
        {dark ? <i className="bi bi-sun-fill"></i> : <i className="bi bi-moon-fill"></i>}
      </button>
    </header>
  );
};

export default Header;
